import Title from 'components/landing/Title';
import Testimonials from './Testimonials';
import baptism from 'assets/img/gallery/Baptism.JPG';
import womensFreshStart from 'assets/img/gallery/WomensFreshStart.jpg';
import smallGroup from 'assets/img/gallery/SmallGroup2.jpg';

export default function TestimonialSection() {
    return (
        <section className="pt-8 pb-50 bg-gray-100">
            <div id='test' className="container max-w-7xl mx-auto px-4">
                <Title heading="Testimonials" >
                    Throughout various prison visits, we have recieved many
                    testimonials from inmates. Some content has been 
                    redacted for privacy purposes.
                </Title>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-16">
                    <img src={baptism} alt="Baptism service" className="w-full h-48 object-cover rounded-lg shadow-lg" />
                    <img
                        src={womensFreshStart}
                        alt="Women's Fresh Start program"
                        className="w-full h-48 object-cover rounded-lg shadow-lg"
                        style={{ objectPosition: '58% center' }}
                    />
                    <img src={smallGroup} alt="Small group gathering" className="w-full h-48 object-cover rounded-lg shadow-lg" />
                </div>
                <div id='test2' className="flex flex-wrap pb-20">
                    <Testimonials/>
                </div>
            </div>
        </section>
    );
}
